module.exports = __webpack_public_path__ + "img/16.97d1500c.jpg";